<div class="form-control">
    <ng-container *ngIf="label">
      <label [for]="inputId" class="bg-[var(--white)] text-[var(--black)] font-semibold uppercase">
        {{ label }}
      </label>
    </ng-container>
    
    <div class="mt-1 relative">
      <ngx-intl-tel-input
      [cssClass]="'custom-phone-input'"
      [preferredCountries]="preferredCountries"
      [enableAutoCountrySelect]="true"
      [enablePlaceholder]="false"
      [searchCountryFlag]="true"
      [searchCountryField]="[
        SearchCountryField.Iso2,
        SearchCountryField.Name
      ]"
      [selectFirstCountry]="false"
      [selectedCountryISO]="CountryISO.Panama"
      [maxLength]="15"
      [phoneValidation]="true"
      [separateDialCode]="separateDialCode"
      [numberFormat]="PhoneNumberFormat.National"
      [enablePlaceholder]="true"
      [customPlaceholder]="placeholder"
      
      name="phone"
      [formControl]="control"
          />

      <div *ngIf="icon" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <fa-icon [icon]="icon" class="text-[var(--grey)]" size="2xl"></fa-icon>
      </div>
    </div>
  
    <ng-container *ngIf="control.invalid && control.dirty && control.touched">
      <div *ngFor="let err of control.errors | keyvalue" class="mt-2 font-bold text-[14px]/[14px]" style="color: red;">
        {{ errorMessages[err.key] ? errorMessages[err.key] : 'Hay un error en este campo' }}
      </div>
    </ng-container>
  </div>
